import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Grid, Box, Typography, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { ShaDowBox } from "../../../../components/boxes";
import { CustomPieChart } from "../../../../components/charts";
import { NoDataCard } from "../../../../components/parts";
import { getData } from "../../../../services";
import { getPercent } from "../../../../services/utils";

const useStyles = makeStyles(() => ({
  connections: {
    marginLeft: 30,
    paddingTop: 25,
    marginBottom: 5,
  },
  text: {
    fontWeight: 700,
    textAlign: "center",
    marginBottom: 30,
  },
  box: {
    height: 270,
  },
}));

export const MetersConnectionStatus = () => {
  const classes = useStyles();
  const [totalMeters, setTotalMeters] = useState();
  const [chartData, setChartData] = useState();
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);

  useEffect(() => {
    getData(`/praas/v1/buildings/connection-status/`, (data) => {
      setTotalMeters(data.meters_count);

      if (data.meters_count > 0) {
        setChartData([
          {
            name: "Connected",
            value: data.statuses?.connected || 0,
            key: "connected",
            centerLabel: "are connected",
            centerSuffixLabel: "connected",
            color: COLORS.green,
            unit: "%",
            value_position: "inline",
            value_percent: data.statuses?.connected
              ? getPercent(data.statuses?.connected, data.meters_count)
              : 0,
          },
          {
            name: "Ready",
            value: data.statuses?.ready || 0,
            key: "ready",
            centerLabel: "are ready",
            centerSuffixLabel: "ready",
            color: COLORS.purple,
            unit: "%",
            value_position: "inline",
            value_percent: data.statuses?.ready
              ? getPercent(data.statuses?.ready, data.meters_count)
              : 0,
          },
          {
            name: "Stand By",
            value: data.statuses?.stand_by || 0,
            key: "stand_by",
            centerLabel: "are stand_by",
            centerSuffixLabel: "stand_by",
            color: COLORS.yellow,
            unit: "%",
            value_position: "inline",
            value_percent: data.statuses?.stand_by
              ? getPercent(data.statuses?.stand_by, data.meters_count)
              : 0,
          },
          {
            name: "Pending",
            value: data.statuses?.pending || 0,
            key: "pending",
            centerLabel: "are pending",
            centerSuffixLabel: "pending",
            color: COLORS.blue,
            unit: "%",
            value_position: "inline",
            value_percent: data.statuses?.pending
              ? getPercent(data.statuses?.pending, data.meters_count)
              : 0,
          },
          {
            name: "Missing",
            value: data.statuses?.missing || 0,
            key: "missing",
            centerLabel: "are missing",
            centerSuffixLabel: "missing",
            color: COLORS.red,
            unit: "%",
            value_position: "inline",
            value_percent: data.statuses?.missing
              ? getPercent(data.statuses?.missing, data.meters_count)
              : 0,
          },
        ]);
      }
    });
    return () => {
      setTotalMeters();
      setChartData();
    };
  }, [cluster, segments, selectedCountries]);

  return (
    <ShaDowBox container>
      <Typography className={classes.connections} variant="h4">
        Meters PRaaS-Connection Status
      </Typography>
      <Grid container>
        <Box style={{ width: "100%" }}>
          {totalMeters && chartData ? (
            <Grid item>
              <Box className={classes.box}>
                <CustomPieChart name="ConnectionStatus" data={chartData} />
              </Box>
            </Grid>
          ) : (
            <Grid item>
              <NoDataCard
                type="pie"
                withShaDowBox={false}
                boxStyle={{ paddingBottom: 24 }}
                gridStyle={{ height: 181 }}
              />
            </Grid>
          )}
        </Box>
      </Grid>
    </ShaDowBox>
  );
};
